import { useState } from 'react'

import { useI18n } from '@muse/i18n'
import type { TAudioSimple } from '@core/models'
import { AsyncCommentListContainer } from '@features/comment'
import { useGetPlaybackTime } from '@features/audio-player'

import { AudioAdditionalInfo } from '../components/audio-additional-info/AudioAdditionalInfo'

import { AudioDetailsContainer } from './AudioDetailsContainer'

type TAudioAdditionalInfoContainerProps = {
    audio: TAudioSimple
}

export const AudioAdditionalInfoContainer = ({ audio }: TAudioAdditionalInfoContainerProps) => {
    const { t } = useI18n()
    const [activeTab, setActiveTab] = useState<'details' | 'comments'>('details')
    const getPlaybackTime = useGetPlaybackTime()
    return (
        <AudioAdditionalInfo
            activeTab={activeTab}
            onTabChange={tab => setActiveTab(tab === 'comments' ? 'comments' : 'details')}
            detailsLabel={t('i18n.audioTabDetails')}
            commentsLabel={t('i18n.audioTabComments')}
            detailsSlot={<AudioDetailsContainer audio={audio} />}
            commentsSlot={
                <AsyncCommentListContainer
                    entityId={audio.id}
                    entityType="audio"
                    getPlaybackTime={getPlaybackTime}
                />
            }
        />
    )
}
